import script from "./AddDocumentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddDocumentModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddDocumentModal.vue?vue&type=style&index=0&id=d0fa19b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0fa19b2"]])

export default __exports__